import * as React from "react";
import {
  CPLN_HELM_RELEASE_PREFIX,
  CPLN_HELM_RELEASE_LEGACY_PREFIX,
  homeLink,
  linksOf,
  request,
} from "../../services/cpln";
import { Secret } from "../../schema/types/secret/entity";
import { Table } from "../../newcomponents/table/table";
import { InternalLink } from "../../newcomponents/table/components/InternalLink";
import { Alert } from "antd";

interface ReleaseItem {
  name: string;
  isLegacy: boolean;
}
export const HelmReleasesList: React.FC = () => {
  const [isLoadingLegacy, setIsLoadingLegacy] = React.useState(true);
  const [errorLegacy, setErrorLegacy] = React.useState("");
  const [legacyReleases, setLegacyReleases] = React.useState<string[]>([]);

  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const [releases, setReleases] = React.useState<string[]>([]);

  React.useEffect(() => {
    fetchLegacyReleases();
    fetchReleases();
  }, []);

  async function fetchLegacyReleases() {
    try {
      setErrorLegacy("");
      setIsLoadingLegacy(true);
      let _items: Secret[] = [];
      let nextLink: string | undefined = undefined;

      const url = homeLink("secret") + "/-query";
      const body = {
        kind: "secret",
        spec: {
          match: "all",
          terms: [
            { op: "~", property: "name", value: CPLN_HELM_RELEASE_LEGACY_PREFIX },
            { op: "!exists", tag: "console/marketplace" },
          ],
        },
      };
      const { data } = await request({ method: "post", url: url, body: body });
      _items = data.items;
      nextLink = linksOf(data).next;

      while (nextLink) {
        const { data } = await request({ url: nextLink, body: body });
        nextLink = linksOf(data).next;
        _items = _items.concat(data.items);
      }
      setLegacyReleases(
        _items
          .filter((i) => i.name.startsWith(CPLN_HELM_RELEASE_LEGACY_PREFIX))
          .map((i) => i.name.replace(CPLN_HELM_RELEASE_LEGACY_PREFIX, "")),
      );
      setIsLoadingLegacy(false);
    } catch (e) {
      setIsLoadingLegacy(false);
      let errorMessage = e?.response?.data?.message;
      if (!errorMessage) errorMessage = e.message;
      setErrorLegacy(errorMessage);
    }
  }

  async function fetchReleases() {
    try {
      setError("");
      setIsLoading(true);
      let _items: Secret[] = [];
      let nextLink: string | undefined = undefined;

      const url = homeLink("secret") + "/-query";
      const body = {
        kind: "secret",
        spec: {
          match: "all",
          terms: [
            { op: "~", property: "name", value: CPLN_HELM_RELEASE_PREFIX },
            { op: "!exists", tag: "cpln/marketplace" },
          ],
        },
      };
      const { data } = await request({ method: "post", url: url, body: body });
      _items = data.items;
      nextLink = linksOf(data).next;

      while (nextLink) {
        const { data } = await request({ url: nextLink, body: body });
        nextLink = linksOf(data).next;
        _items = _items.concat(data.items);
      }
      const secrets = _items.filter((i) => i.name.startsWith(CPLN_HELM_RELEASE_PREFIX));
      let releaseNames: string[] = [];
      for (const secret of secrets) {
        const releaseName = (secret.tags || {})["name"];
        if (!!releaseName && !releaseNames.includes(releaseName)) {
          releaseNames.push(releaseName);
        }
      }
      setReleases(releaseNames);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      let errorMessage = e?.response?.data?.message;
      if (!errorMessage) errorMessage = e.message;
      setError(errorMessage);
    }
  }

  if (error || errorLegacy) {
    return <Alert type={"error"} message="Error" description={error || errorLegacy} />;
  }

  return (
    <>
      <Table<ReleaseItem>
        tableId="helm-release-list"
        data={[
          ...releases.map((r) => ({ name: r, isLegacy: false })),
          ...legacyReleases.map((r) => ({ name: r, isLegacy: true })),
        ]}
        enableFilter
        title={"Helm Releases"}
        columns={[
          {
            id: "name",
            label: "Name",
            cell: (p) => {
              const item = p.row.original;
              return (
                <div className="flex items-center" style={{ height: 56 }}>
                  <InternalLink label={item.name} to={item.isLegacy ? `legacy/${item.name}` : item.name} />
                </div>
              );
            },
          },
        ]}
        isLoading={isLoading || isLoadingLegacy}
      />
    </>
  );
};
